module.exports = __webpack_public_path__ + "static/media/FX-LSDtypewriter.557647f5.wav";